import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { OpportunitiesDetailsScreenComponent } from './OpportunitiesDetailsScreen.types'
import { useOpportunitiesDetailsScreen } from './useOpportunitiesDetailsScreen'

const OpportunitiesDetailsScreenDesktop = lazy(() => import('./OpportunitiesDetailsScreen.desktop'))

export const OpportunitiesDetailsScreen: OpportunitiesDetailsScreenComponent = ({
  navigation,
  route
}) => {
  const props = useOpportunitiesDetailsScreen({ navigation, route })

  const Screen = OpportunitiesDetailsScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
